import type { Observable } from 'rxjs';
import type { ChatBotHttpDataResponse } from '@common/types/http-response.type';
import type { ChatBotChain } from '@common/types/chat-bot-chain.type';

import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseHttpService } from '@common/services/REST/base.http.service';

@Injectable({
    providedIn: 'root',
})
export class ChatBotChainsHttpService extends BaseHttpService {
    public getChatBotChains(messenger: string, botId: string): Observable<ChatBotChain[]> {
        if (messenger === 'viber') {
            messenger = 'vb';
        }

        return this.http
            .get<ChatBotHttpDataResponse<ChatBotChain>>(`/api/${messenger}-service/bots/${botId}/chains`, {
                params: { size: 500 },
            })
            .pipe(
                shareReplay(),
                map((response) => response.data.list)
            );
    }

    public getTelegramChainLink(botId: string, chainId: string): Observable<any> {
        return this.http.get(`/api/telegram-service/bots/${botId}/chains/${chainId}/url`).pipe(shareReplay());
    }
}
